export const CLIENT_VERSION = "939e31b9ee1ff49f7460f913ce39b4466b8e55cc";
